import { API_PREFIX } from '@/config/api'
import type { OrderCreateModel, OrderModel, OrderStateUpdateModel } from '@/types/models/OrderModel'
import {
    GET_RESPONSE_TYPE_BLOB_REQUEST,
    MULTIPART_FORMDATA_REQUEST
} from '@rfc/rfc-components-library/config'
import { api } from '@rfc/rfc-components-library/helpers'
import type { PaginationDataType, PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'
import type { AxiosResponse } from 'axios'
import type { OrderFilters } from '../types/components/Filters/OrderFiltersType'
import { buildOrderFormData } from '../utils/odooFormData'

const ORDERS_PREFIX = `${API_PREFIX}/orders`
const ODOO_ORDERS_PREFIX = `${API_PREFIX}/odoo/orders`

const ordersApi = {
    getOrders: (
        params?: Partial<PaginationType & OrderFilters>
    ): Promise<PaginationDataType<OrderModel>> =>
        api.get(`${ORDERS_PREFIX}${buildQueryUrl(params)}`).then(res => res.data),
    getOrder: (id: number): Promise<AxiosResponse<OrderModel>> =>
        api.get(`${ORDERS_PREFIX}/${id}`).then(res => res.data),
    createOrder: (data: OrderCreateModel): Promise<AxiosResponse<OrderModel>> =>
        api
            .post(ODOO_ORDERS_PREFIX, buildOrderFormData(data), MULTIPART_FORMDATA_REQUEST)
            .then(res => res.data),
    updateOrder: (id: number, data: OrderStateUpdateModel): Promise<AxiosResponse<OrderModel>> =>
        api.patch(`${ORDERS_PREFIX}/${id}/state`, data),

    deleteOrder: (id: number): Promise<AxiosResponse<{ message: string }>> =>
        api.delete(`${ORDERS_PREFIX}/${id}`),

    // `csv_path` / `logo_path` sont des clés du disque privé du serveur : seules
    // ces routes servent les fichiers, et elles exigent l'en-tête Authorization.
    downloadOrderItemCsv: (orderId: number, itemId: number): Promise<Blob> =>
        api
            .get(`${ORDERS_PREFIX}/${orderId}/items/${itemId}/csv`, GET_RESPONSE_TYPE_BLOB_REQUEST)
            .then(res => res.data),

    downloadOrderItemLogo: (orderId: number, itemId: number): Promise<Blob> =>
        api
            .get(`${ORDERS_PREFIX}/${orderId}/items/${itemId}/logo`, GET_RESPONSE_TYPE_BLOB_REQUEST)
            .then(res => res.data)
}

export default ordersApi
